import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import "./app/styles.css";
import "./app/reveal.css";
import "./app/landing.css";
import { registerSw } from "./lib/sw";
import { installErrorReporting } from "./lib/errors";
import { legacyRewrite } from "./app/routes";
registerSw();
installErrorReporting();
// A printed short link from the old app lands on /word?reveal=<token>; tidy it into the hash
// route before React reads the location (the live app did the same).
try { const tidy = legacyRewrite(window.location); if (tidy) history.replaceState(null, "", tidy); } catch { /* leave the URL alone */ }

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
